// export { Tabs } from './Tabs'
// export { Workflow } from './Workflow'

export const Tabs = () => {
  console.error('Tabs is deprecated in this version')
  return null
}
Object.assign(Tabs, {
  lazy: false,
  layout: 'Tabs',
})

export const Workflow = () => {
  console.error('Workflow is deprecated in this version')
  return null
}
Object.assign(Workflow, {
  lazy: false,
  layout: 'Workflow',
})
